export const modalOfIpcTable = {
    alertMessage: 'IPCコードは最大50個まで選択可能です',
    modalTitle: '絞り込みIPCコードの選択',
    userInputPlaceholder: 'キーワード or IPCコードを入力してください',
    switchLabel: '選択中のIPCコードのみ表示する',
    ipcCode: 'IPCコード',
    ipcSubclass: 'IPCサブクラス',
    ipcMainGroup: 'IPCメイングループ',
    ipcSubgroup: 'IPCサブグループ',
    factorLoadQuantity: '因子負荷量',
    numberOfPatents: '特許出願数',
    completionButton: '完了'
}
